import type { NextRequest } from "@/modules/fetch/types"
import type { FooterLink } from "@/modules/headerFooterFO/Footer/types"
import type { I18nLocale } from "@/modules/i18n/types"

import { getFooterLinksFromKontent } from "./getFooterLinksFromKontent"
import { getFooterLinksFromStrapi } from "./getFooterLinksFromStrapi"

type GetFooterLinksParams = {
  locale: I18nLocale
  req?: NextRequest
  useStrapi: boolean
  token?: string
}

export const getFooterLinks = async (params: GetFooterLinksParams): Promise<FooterLink[]> => {
  const { useStrapi } = params

  if (useStrapi) {
    return getFooterLinksFromStrapi(params)
  }

  return getFooterLinksFromKontent(params)
}
